import { useEffect } from 'react'
import useCheckinDataColumns from '../../hooks/useCheckinDataColumns'
import { createLogger } from '../../../../app/logger'
import {
  useTheme,
} from '@mui/material'
import MaterialTable from '@material-table/core'
import { CheckinEntry } from '../../../../app/types'
import useAppSelector from '../../../../hooks/useAppSelector'
import { getEntriesUrlFetchInProgressSelector } from '../../../data/dataSlice'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'CheckinPageDataTable'
})

const PAGE_SIZE_OPTIONS = [10, 20, 100]

export function CheckinPageDataTable({
  data = []
}: {
  data: CheckinEntry[]
}) {
  const columns = useCheckinDataColumns()
  const theme = useTheme()
  const isLoading = useAppSelector(getEntriesUrlFetchInProgressSelector)

  const scrollToTop = () => {
    const element = document.getElementById('pageHeader')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  useEffect(() => {
    const handler = setTimeout(scrollToTop, 50)
    return () => clearTimeout(handler)
  }, [isLoading])

  return (
    <div
      className={'checkin-page-table'}
      data-cy={'checkin-page-table'}
      style={{ width: '100%' }}
    >
      <MaterialTable
        columns={columns}
        data={data}
        options={{
          pageSize: 10,
          actionsColumnIndex: 0,
          emptyRowsWhenPaging: false,
          pageSizeOptions: PAGE_SIZE_OPTIONS,
          rowStyle: (_, i) => ({
            backgroundColor: i % 2
              ? theme.palette.background.default
              : 'transparent'
          }),
          search: false,
          showTitle: false,
          toolbar: false,
        }}
      />
    </div>
  )
}
